<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
    <vx-tour :steps="steps" v-if="!disableThemeTour && (windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" />

<!--    <the-customizer-->
<!--      v-if                    = "!disableCustomizer"-->
<!--      :footerType             = "footerType"-->
<!--      :hideScrollToTop        = "hideScrollToTop"-->
<!--      :navbarType             = "navbarType"-->
<!--      :navbarColor            = "navbarColor"-->
<!--      :routerTransition       = "routerTransition"-->
<!--      @toggleHideScrollToTop  = "toggleHideScrollToTop"-->
<!--      @updateFooter           = "updateFooter"-->
<!--      @updateNavbar           = "updateNavbar"-->
<!--      @updateNavbarColor      = "updateNavbarColor"-->
<!--      @updateRouterTransition = "updateRouterTransition" />-->
    <v-nav-menu v-if="canDelete == 1"
      :navMenuItems = "navMenuItems"
      title         = "Scoolio"
      parent        = ".layout--main" />
      <v-nav-menu v-if="canDelete == 0"
      :navMenuItems = "dynamic"
      title         = "Scoolio"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu v-if="canDelete == 1"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />

        <h-nav-menu v-if="canDelete == 0"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="dynamic" />
    </template>


    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap justify-between items-center mb-6">
                <!-- <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div> -->

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />
                <!-- DROPDOWN -->
                <div class="flex flex-wrap">

                <vs-tooltip color="primary" text="Summary" position="top" class="mr-2 md:block hidden cursor-pointer">

                  <vs-button v-if="settingsIndex > -1" radius icon="icon-clipboard" icon-pack="feather" @click="chngSummaryStatus" />
                </vs-tooltip>
                <vs-tooltip color="primary" text="Settings" position="top" class="ml-auto md:block hidden cursor-pointer">
                  <vs-dropdown v-if="settingsIndex > -1 && globalSettings[settingsIndex].options.length>0" vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                    <vs-button radius icon="icon-settings" icon-pack="feather" />

                    <vs-dropdown-menu>
                      <vs-dropdown-item v-for="(settingOption, index) in globalSettings[settingsIndex].options" :key="index">
                        <div v-if="settingOption.url_path" @click="$router.push(settingOption.url_path).catch(() => {})" class="flex items-center">
                          <span>{{ settingOption.option_name }}
                          </span>
                        </div>

                        <!-- <div v-if="settingOption.popup_name === 'enrollPopUp' && checkManualEnrollmentPermission()" @click="enrollPopUp = true" class="flex items-center">
                          <span>{{ settingOption.option_name }}


                          </span>
                        </div> -->
                      </vs-dropdown-item>
                      <vs-dropdown-item v-if="$route.name == 'schedule'">
                        <span @click="$router.push({name: 'Settings', params: {tabularIndex: 4}}).catch(() => {})">School Schedule Settings</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item v-if="$route.name == 'schedule'">
                        <span @click="$router.push({name: 'Settings', params: {tabularIndex: 1}}).catch(() => {})">Date Time Settings</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>

                  </vs-dropdown>
                </vs-tooltip>
                </div>
              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- <the-footer /> -->
    </div>

    <!-- <ScheduleOneToComponent></ScheduleOneToComponent> -->

    <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup schedule-popup" v-if="enrollPopUp" :class="{show: enrollPopUp}">
      <div class="cstm-modal">
        <div class="header">
          <h3>Schedule One To One Form</h3>
          <button @click="enrollPopUp = false" class="close-modal">&times;</button>
        </div>
        <div class="modal-content">
          <ScheduleOneToComponent
          v-if="enrollPopUp"
          @scheduleAdded="scheduleAdded"
          ></ScheduleOneToComponent>

        </div>
      </div>
    </div>
  </div>
</template>


<script>

import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import {navMenu}        from '@/layouts/components/vertical-nav-menu/navMenu.js'
import TheCustomizer       from '@/layouts/components/customizer/TheCustomizer.vue'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import  ScheduleOneToComponent from '@/components/course/ScheduleOneToComponent.vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'


import {analyticsStatus} from '@/api/analyticsSettings'
import { mapGetters, mapActions } from 'vuex'

const VxTour = () => import('@/components/VxTour.vue')
export default {
  components: {
    // RightMostNav,
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    VxTour,
    ScheduleOneToComponent

  },
  mixins:[navMenu, PermissionMiddleware],
  data () {
    return {
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      canDelete         : localStorage.getItem('role_permission'),
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [
        {
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.customizer-btn',
          content : 'Customize template based on your preference',
          params  : {
            placement: 'left'
          }
        },
        {
          target  : '.vs-button.buy-now',
          content : 'Buy this awesomeness at affordable price!',
          params  : {
            placement: 'top'
          }
        }
      ],
      globalSettings    : [
        {
          module_name: 'admin-dashboard',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },
        {
          module_name: 'teacher-dashboard',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },
        {
          module_name: 'leads', // Use name from router.js in lowercase
          options: [
            { option_name: 'CRM Field Management', url_path: '/pages/customvaluesettings/Leads' },
            { option_name: 'CRM Filter Management', url_path: '/pages/filterlist/Leads' },
            { option_name: 'CRM Field Rearrangement', url_path: '/pages/Field-management/Leads' },
            { option_name: 'CRM Status Management', url_path: '/pages/statusmanagement' },
            { option_name: 'CRM Summary Settings', url_path: '/pages/summery-settings?tab=crm' }
          ]
        },
        {
          module_name: 'schedule',
          options: [{ option_name: 'Student Enrollment', popup_name: 'enrollPopUp' }]
        },
        {
          module_name: 'students',
          options: [
            { option_name: 'Students Field Management', url_path: '/pages/customvaluesettings/Client' },
            { option_name: 'Students Filter Management', url_path: '/pages/filterlist/Client/student_list' },
            { option_name: 'Students Field Rearrangement', url_path: '/pages/Field-management/Students/student_list' },
            { option_name: 'Students Summary Settings', url_path: '/pages/summery-settings?tab=students' }
          ]
        },
        {
          module_name: 'staff',
          options: [
            { option_name: 'Staff Field Management', url_path: '/pages/customvaluesettings/Staff' },
            { option_name: 'Staff Filter Management', url_path: '/pages/filterlist/Staff/staff_list' },
            { option_name: 'Staff Field Rearrangement', url_path: '/pages/Field-management/Staff/staff_list' },
            { option_name: 'Staff Summary Settings', url_path: '/pages/summery-settings?tab=staff' }
          ]
        },
        {
          module_name: 'courselisting',
          options: [
            { option_name: 'Course Summary Settings', url_path: '/pages/summery-settings?tab=course' },
            { option_name: 'Course Notification Settings', url_path: '/pages/communication/settings?tab=course' }
          ]
        },
        {
          module_name: 'report',
          options:[]
          // options: [{ option_name: 'Report Notification Settings', url_path: '/pages/communication/settings?tab=reports' }]
        },
        {
          module_name: 'coursework',
          options:[]
          // options: [{ option_name: 'Report Notification Settings', url_path: '/pages/communication/settings?tab=reports' }]
        },
        {
          module_name: 'homework',
          options:[]
          // options: [{ option_name: 'Homework Notification Settings', url_path: '/pages/communication/settings?tab=homework' }]
        },
        {
          module_name: 'finance',
          options:[]
          // options: [{ option_name: 'Homework Notification Settings', url_path: '/pages/communication/settings?tab=homework' }]
        },
        {
          module_name: 'manual-invoice',
          options:[]
          // options: [{ option_name: 'Homework Notification Settings', url_path: '/pages/communication/settings?tab=homework' }]
        },
        {
          module_name: 'staffpayout',
          options:[]
          // options: [{ option_name: 'Homework Notification Settings', url_path: '/pages/communication/settings?tab=homework' }]
        },
        {
          module_name: 'exam',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        }, {
          module_name: 'attendance',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        }, {
          module_name: 'classes',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },
        {
          module_name: 'subjects',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },
        {
          module_name: 'rooms',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },

        {
          module_name: 'inventory',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },
        {
          module_name: 'grade',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },
        {
          module_name: 'attendanceteacher',
          options:[]
          // options: [{ option_name: 'Exam Notification Settings', url_path: '/pages/communication/settings?tab=exams' }]
        },
        {
          module_name: 'tasks-project',
          options: [
            { option_name: 'Task Summary Settings', url_path: '/pages/summery-settings?tab=task' },
            { option_name: 'Project Summary Settings', url_path: '/pages/summery-settings?tab=projects' }
          ]
        },
        {
          module_name: 'email',
          options: [{ option_name: 'Email Notification Settings', url_path: '/pages/communication/settings?tab=communication' }]
        },
        {
          module_name: 'blogs-post',
          options: [{ option_name: 'Blog Notification Settings', url_path: '/pages/communication/settings?tab=communication' }]
        },
        {
          module_name: 'messaging',
          options: [{ option_name: 'Chat Notification Settings', url_path: '/pages/communication/settings?tab=communication' }]
        }
      ],
      settingsIndex: null,
      enrollPopUp: false,
      course_start_date: '',
      course_start_time: '',
      configStartTiming: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true
      }
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle

      this.setGlobalSettingsOptions()
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    ...mapGetters(['get_role_permission', 'get_status', 'get_maxi_min']),

    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth }
  },
  methods: {
    ...mapActions(['SET_Analytics_STATUS', 'SET_Analytics_Maxi_Min_STATUS']),
    async chngSummaryStatus () {

      const view_status = this.get_status
      const view_state = this.get_status.view_state === 0 ? 1 : 0
      view_status.view_state = view_state
      const payload = {
        analytics_view_state_id:this.get_status.analytics_view_state_id,
        customer_id:localStorage.getItem('customer_id'),
        module_id: this.get_status.module_id,
        type:0,
        view_state
      }

      const {data} = await analyticsStatus(payload)

      this.SET_Analytics_STATUS(data.data.view_state)
      this.SET_Analytics_Maxi_Min_STATUS(view_state)
    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    },
    setGlobalSettingsOptions () {
      const page_name = this.$route.name.toLowerCase()

      const index = this.globalSettings.findIndex(settingsFor => {
        return settingsFor.module_name === page_name
      })
      this.settingsIndex = index
    },
    scheduleAdded () {
      this.enrollPopUp = false
    }
  },
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Schedule')
    }

    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)


    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })

    this.setGlobalSettingsOptions()
  },
  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>

